///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface Breadcrumb {
    id: number;
    name: string;
}

@Component({
    selector: 'winde-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthBreadCrumbsComponent {
    @Input() breadcrumbs: Breadcrumb[];
    @Input() customClass: string;
    @Output() changeBreadcrumb: EventEmitter<number> = new EventEmitter<number>();

    public changeCurrentState(item: Breadcrumb) {
        this.changeBreadcrumb.emit(item.id);
    }
}
